// One shared, session-long copy of "every dancer name in the app" (taken from uploaded results),
// plus the matching index built from it.
//
// Loading is awaited by whoever needs it – a start list pasted a moment after the screen opens waits
// for the names instead of silently matching against an empty list. A failed load is not remembered,
// so the next call retries.

import { cachedGetDocs } from './firestoreCache';
import { buildNameIndex } from './dancerMatching';

const MAX_AGE_MS = 30 * 60 * 1000;
let pending = null;
let loadedAt = 0;

export function loadDancerDirectory() {
  if (pending && Date.now() - loadedAt < MAX_AGE_MS) return pending;
  loadedAt = Date.now();
  pending = cachedGetDocs('competitions').then((snap) => {
    const names = new Set();
    snap.forEach((d) => {
      (d.data().results || []).forEach((r) => {
        const name = String(r.dancerName || '').trim();
        if (name) names.add(name);
      });
    });
    const list = [...names].sort((a, b) => a.localeCompare(b));
    return { names: list, index: buildNameIndex(list) };
  });
  pending.catch(() => { pending = null; loadedAt = 0; }); // allow a retry after a failure
  return pending;
}

export const resetDancerDirectory = () => { pending = null; loadedAt = 0; };
